import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const FixButton = styled.div`
	position: fixed;
	bottom: 65px;
	left: 0;
	width: 100%;
	padding: 20px;
	background-color: ${({ disabled }) =>
		disabled ? CONFIG.colors.greyLight : CONFIG.colors.primary};
	text-align: center;
	color: ${CONFIG.colors.white};
	font-size: ${CONFIG.fontSizes.lg};
	font-family: ${CONFIG.fonts.semiBold};
	cursor: pointer;
`;
